import $ from 'jquery';
import {events, dispatchEvents} from './gtm-events';

const dataKey = 'event';
const nodeSelector = `[data-${dataKey}]`;

/**
 *
 * @param {jQuery} element
 * @param {Object} payload
 * @returns {Boolean}
 */
function isValidEvent(element, payload = {}) {
  const keys = Object.keys(payload);

  return (element.length && !keys.length) || !element.length;
}

/**
 * @param {Event} event
 * @param {Object} data
 */
function handleEvent(event, data) {
  if (!window.dataLayer) {
    return;
  }

  const payload = data || event.detail || {};
  const $match = $(event.target).closest(nodeSelector);

  if (!isValidEvent($match, payload)) {
    return;
  }

  const type = $match.data(dataKey) || event.type;
  const fn = events[type];

  if (!fn) {
    return;
  }

  fn($match, payload);
}

function GTM() {
  const dispatchEventString = Object.keys(dispatchEvents).join(' ');

  $(document).on('click', nodeSelector, handleEvent);
  $(document).on(dispatchEventString, handleEvent);
}

GTM();
